export default "__VITE_ASSET__AvaXstY6__"